import ConsecutiveSentences from './modules/ConsecutiveSentences';
import GradeLevel from './modules/GradeLevel';
import SentenceLength from './modules/SentenceLength';
import ParagraphLength from './modules/LongParagraphs';
import PassiveVoice from './modules/PassiveVoice';
import ReadingScore from './modules/ReadingScore';
import ScriptureSaturation from './modules/ScriptureSaturation';
import TransitionalWords from './modules/TransitionalWords';
import WordCount from './modules/WordCount';
import SubheadingDistribution from './modules/SubheadingDistribution';
import { BuilderPreferences } from '../../entities/BuilderPreferences';

export default function Analyzer(subheadingCount:number = 0, preferences:BuilderPreferences) {
    const {hideConsecutiveSentences, hideFleschReadingEase, hideParagraphLength, hidePassiveVoice, 
        hideScriptureSaturation, hideSentenceLength, hideSubheadingDistribution, hideTransitionalWords} = preferences;

    return analyze;
    
    function analyze(tree:any, file:any){
        file.improvements = [];
        file.goodResults = [];

        WordCount()(tree,file);

        GradeLevel()(tree,file);

        if(hideConsecutiveSentences === false){
            ConsecutiveSentences()(tree,file);
        }
        
        if(hideFleschReadingEase === false){
            ReadingScore()(tree,file);
        }
        
        if(hideParagraphLength === false){
            ParagraphLength()(tree,file);
        }
        
        if(hidePassiveVoice === false){
            PassiveVoice()(tree,file);
        }
        
        if(hideSentenceLength === false){
            SentenceLength()(tree,file);
        }

        if(hideScriptureSaturation === false){
            ScriptureSaturation()(tree,file);
        }
        
        if(hideSubheadingDistribution === false){
            SubheadingDistribution(subheadingCount)(tree,file);
        }

        if(hideTransitionalWords === false){
            TransitionalWords()(tree,file);
        }
    }
}